<template>
  <span class="rounded px-1" :class="getClassName(color)">
    <span class="m-0 font-size-14 text-center font-weight-500">{{ text }}</span>
  </span>
</template>

<script>

export default {
  name: "TagItem",
  props: {
    text: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: 'red'
    },
  },
  methods: {
    getClassName(colorEnum) {
      switch (colorEnum) {
        case "white":
          return 'tag-color-white';
        case "blue":
          return 'tag-color-blue';

        case "green":
          return 'tag-color-green';

        case "yellow":
          return 'tag-color-yellow';

        case "red":
        default:
          return 'tag-color-red';
      }
    }
  }
}
</script>

<style scoped>

.tag-color-red {
  background-color: #FEE4DE;
  color: #FF3709
}

.tag-color-blue {
  background-color: #C3F2FB;
  color: #1EB9DA;
}

.tag-color-green {
  background-color: #C9F3E1;
  color: #40BD8B;
}

.tag-color-yellow {
  background-color: #FFE0AB;
  color: #E89100;
}

.tag-color-white {
  border: 0.0625rem solid #E89100;
  /*border-radius: 0.25rem;*/
  background-color: transparent;
  color: #E89100
}

.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
